import React, { Component, Children } from 'react';
import { p as pluginsStrategy, a as pipe } from './pluginsStrategy-f486296d.js';
import { themeStrategy } from 'ricos-styles/libs/themeStrategy';
import { merge } from 'lodash';
import previewStrategy from './previewStrategy/previewStrategy.js';
import { convertRelStringToObject, convertRelObjectToString } from 'wix-rich-content-common/libs/linkConverters';
import { applyBIGenerics } from './biCallbacks/applyGenericParams.js';
import './biCallbacks/mediaUploadBI.js';
import 'wix-rich-content-common/libs/uuid';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class RicosEngine extends Component {
  runStrategies() {
    var _a;
    const {
      cssOverride,
      plugins = [],
      isViewer = false,
      preview,
      theme: ricosTheme,
      isPreviewExpanded = false,
      onPreviewExpand,
      children,
      experiments
    } = this.props;
    if (this.props.schemaType === "RichContent" || !!((_a = this.props.content) == null ? void 0 : _a.nodes)) {
      throw new Error("Draft editor supports only Draft content schema.");
    }
    const content = this.props.content;
    const { theme, html, themeData } = themeStrategy({
      plugins,
      cssOverride,
      ricosTheme,
      experiments
    });
    const htmls = [];
    if (html) {
      htmls.push(html);
    }
    const strategiesProps = merge(
      { theme },
      pluginsStrategy({
        themeData,
        isViewer,
        plugins,
        childProps: children.props,
        cssOverride: theme,
        content,
        experiments
      })
    );
    const _b = previewStrategy({
      isViewer,
      isPreviewExpanded,
      onPreviewExpand,
      previewConfig: preview,
      content
    }), { initialState: previewContent } = _b, previewStrategyResult = __objRest(_b, ["initialState"]);
    return {
      strategyProps: merge(strategiesProps, previewStrategyResult),
      previewContent,
      htmls,
      content
    };
  }
  render() {
    var _a, _b, _c, _d;
    const {
      _rcProps,
      children,
      isMobile,
      addAnchors,
      toolbarSettings,
      modalSettings = {},
      isPreviewExpanded,
      placeholder,
      getContentId,
      RicosModal,
      onError,
      mediaSettings = {},
      linkSettings = {},
      linkPanelSettings = {},
      maxTextLength,
      textAlignment,
      onAtomicBlockFocus,
      experiments,
      iframeSandboxDomain,
      textWrap = true,
      editorCommands
    } = this.props;
    const { strategyProps, previewContent, htmls, content } = this.runStrategies();
    const { useStaticTextToolbar, textToolbarContainer, getToolbarSettings } = toolbarSettings || {};
    const { openModal, closeModal, ariaHiddenId, container, onModalOpen, onModalClose } = modalSettings;
    const { pauseMedia, disableRightClick, fullscreenProps } = mediaSettings;
    const { anchorTarget = "_blank", customAnchorScroll } = linkSettings;
    let { relValue, rel } = linkSettings;
    const {
      blankTargetToggleVisibilityFn,
      nofollowRelToggleVisibilityFn,
      showNewTabCheckbox,
      showNoFollowCheckbox
    } = linkPanelSettings;
    if (blankTargetToggleVisibilityFn) {
      console.warn(
        // eslint-disable-next-line max-len
        `blankTargetToggleVisibilityFn is deprecated, Please use showNewTabCheckbox prop instead.`
      );
      linkPanelSettings.showNewTabCheckbox = ((_a = linkPanelSettings.blankTargetToggleVisibilityFn) == null ? void 0 : _a.call(linkPanelSettings)) || showNewTabCheckbox;
    }
    if (nofollowRelToggleVisibilityFn) {
      console.warn(
        // eslint-disable-next-line max-len
        `nofollowRelToggleVisibilityFn is deprecated, Please use showNoFollowCheckbox prop instead.`
      );
      linkPanelSettings.showNoFollowCheckbox = ((_b = linkPanelSettings.nofollowRelToggleVisibilityFn) == null ? void 0 : _b.call(linkPanelSettings)) || showNoFollowCheckbox;
    }
    if (relValue) {
      console.warn(
        // eslint-disable-next-line max-len
        `relValue is deprecated, Please use rel prop instead.`
      );
      rel = convertRelStringToObject(relValue) || rel;
    }
    relValue = convertRelObjectToString(rel);
    const disableDownload = (mediaSettings == null ? void 0 : mediaSettings.disableDownload) || disableRightClick;
    const isPreview = () => !!(previewContent && !isPreviewExpanded);
    const ricosPropsToMerge = {
      addAnchors,
      isMobile,
      maxTextLength,
      textToolbarType: !isMobile && (textToolbarContainer || useStaticTextToolbar) ? "static" : "inline",
      config: {
        getToolbarSettings,
        uiSettings: { disableDownload, linkPanel: linkPanelSettings }
      },
      initialState: previewContent || content,
      placeholder,
      onError,
      helpers: {
        openModal,
        closeModal,
        isPreview
      },
      disabled: pauseMedia,
      anchorTarget,
      relValue,
      customAnchorScroll,
      textAlignment,
      onAtomicBlockFocus,
      experiments,
      iframeSandboxDomain,
      textWrap
    };
    const mergedRCProps = pipe(
      merge(strategyProps, _rcProps, ricosPropsToMerge, children.props),
      applyBIGenerics(getContentId)
    );
    const modal = /* @__PURE__ */ React.createElement(
      RicosModal,
      __spreadProps(__spreadValues({
        key: "ricosElement",
        parentClass: (_d = (_c = this.props) == null ? void 0 : _c.theme) == null ? void 0 : _d.parentClass,
        ariaHiddenId,
        isModalSuspended: isPreview(),
        container,
        fullscreenProps
      }, mergedRCProps), {
        onModalOpen,
        onModalClose,
        editorCommands
      }),
      Children.only(React.cloneElement(children, mergedRCProps))
    );
    return [...htmls, modal];
  }
}
RicosEngine.defaultProps = { locale: "en", isMobile: false };

export { RicosEngine };
//# sourceMappingURL=RicosEngine.js.map
